import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, FormGroup, FormControlLabel, Checkbox } from "@mui/material";

const MenuTable = ({ menuItems, selectedPermissions, onPermissionChange }) => {
    return (
        <TableContainer sx={{ minWidth: 800 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Module
                        </TableCell>
                        <TableCell>
                            Menu
                        </TableCell>
                        <TableCell>
                            Permissions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {menuItems.map((menu, index) => (
                        <TableRow key={'menu' + index}>
                            <TableCell>{menu.module}</TableCell>
                            <TableCell>{menu.menu}</TableCell>
                            <TableCell>
                                <FormGroup style={{ display: 'flex', flexDirection: 'row' }}>
                                    {menu.permissions.map((permission, pindex) => (
                                        <FormControlLabel
                                            key={'permission' + pindex}
                                            control={<Checkbox checked={selectedPermissions.indexOf(permission.id) > -1} onChange={() => onPermissionChange(permission.id)} />}
                                            label={permission.title}
                                        />
                                    ))}
                                </FormGroup>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default MenuTable;